import { NavItem } from './NavItem';
import type { NavGroupConfig } from './nav';

/** Grupo de itens com rótulo opcional (`.nav-label`). */
export function NavGroup({ label, compact, items }: NavGroupConfig) {
  return (
    <>
      {label && <span className="nav-label">{label}</span>}
      {items.map((it) => <NavItem key={it.to} {...it} compact={compact} />)}
    </>
  );
}
